const TEMPORARY_HIDDEN_SERVICE_MODULE_KEYS = ["telemedicina", "aps_fisica", "aps_digital"] as const;

const TEMPORARY_HIDDEN_SERVICE_MODULE_ROLES = [
  "client_rh",
  "channel_admin",
  "channel_admin_multi",
  "channel_operator",
  "channel_consultant",
] as const;

export const PEOPLE_BASE_ELIGIBLE_SERVICE_MODULE_KEYS = TEMPORARY_HIDDEN_SERVICE_MODULE_KEYS;

export function isTemporaryServiceModuleHiddenForRole(
  role: string | null | undefined,
  moduleKey: string | null | undefined,
) {
  if (!role || !moduleKey) {
    return false;
  }

  return TEMPORARY_HIDDEN_SERVICE_MODULE_ROLES.includes(
    role as (typeof TEMPORARY_HIDDEN_SERVICE_MODULE_ROLES)[number],
  ) && TEMPORARY_HIDDEN_SERVICE_MODULE_KEYS.includes(
    moduleKey as (typeof TEMPORARY_HIDDEN_SERVICE_MODULE_KEYS)[number],
  );
}

export function isChannelStructuralRole(role: string | null | undefined) {
  if (!role) {
    return false;
  }

  return [
    "channel_admin",
    "channel_admin_multi",
    "channel_operator",
    "channel_consultant",
  ].includes(role);
}

export function isPeopleBaseEligibleRole(role: string | null | undefined) {
  if (!role) {
    return false;
  }

  return [
    "admin",
    "salvia_operation_admin",
    "client_rh",
  ].includes(role);
}

type PeopleBaseEligibleService = {
  moduleKey?: string | null;
  serviceKey?: string | null;
  companyHasService?: boolean | null;
  channelHasService?: boolean | null;
  userHasServiceAccess?: boolean | null;
};

export function hasPeopleBaseEligibleServiceAccess(services: PeopleBaseEligibleService[]) {
  return services.some((service) => {
    const key = service.moduleKey ?? service.serviceKey ?? null;
    const isEligibleService = key
      ? PEOPLE_BASE_ELIGIBLE_SERVICE_MODULE_KEYS.includes(
          key as (typeof PEOPLE_BASE_ELIGIBLE_SERVICE_MODULE_KEYS)[number],
        )
      : false;

    const hasIndividualAccess =
      typeof service.userHasServiceAccess === "boolean"
        ? service.userHasServiceAccess
        : Boolean(service.companyHasService || service.channelHasService);

    return isEligibleService && hasIndividualAccess;
  });
}
